import { render, staticRenderFns } from "./FundingType.vue?vue&type=template&id=606f8382"
import script from "./FundingType.vue?vue&type=script&lang=js"
export * from "./FundingType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports